import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';
const GLOBAL = require('../../Globals');

class Notes extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			title : '',
			desc : '',
			attach : '',
			cls : '',
			section : '',
			subject : '',
			_message : '',
			alertClass :'',
			_redirect : false,
			posts : [],
			secs : [],
			subj : [],
			data :[]
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onClick(e){
		
		document.getElementById("noteform").reset();
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.title && this.state.desc && this.state.cls && this.state.section && this.state.subject){
			$("#showLoader").show();
			PostData('assignment/addnotes',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Notes Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("noteform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 
			$("#showLoader").show();
			PostData('assignment/deletenotes',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Notes Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Subject',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	componentDidMount() {
		 
		this.getdata();
		this.getclass();
	}
	
	/** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('assignment/getnotes').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/academic/assignment/editnotes/' + this.state.idd} />);

	}
	
	  var items = this.state.posts;
	  var sec = this.state.secs;
	  var sub = this.state.subj;
	  
	
	  /** get Section By Class **/
	$("#clas").change(function(){
		var fr = $(this).val();
		$("#showLoader").show();
		$.get(GLOBAL.BASE_URL+'section/getsectsbyclass/'+fr,function(o){
			$("#showLoader").hide();
			//$("#acHead").removeClass('chosen_a');
			$("#secs").html('');
			$('#secs')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Section- ')); 
			$.each(o,function(key,value){			
				   $('#secs')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.secs)); 	
										
			});
			
		},'json');
	
	});
	
	/** get Subject By Class & Section **/
	$("#secs").change(function(){
		var cr = $("#clas").val();
		var fr = $(this).val();
		$("#showLoader").show();
		$.get(GLOBAL.BASE_URL+'subjectallocation/getsubjectbysec/'+cr+'/'+fr,function(o){
			$("#showLoader").hide();
			//$("#acHead").removeClass('chosen_a');
			$("#sub").html('');
			$('#sub')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Subject- ')); 
			$.each(o,function(key,value){			
				   $('#sub')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.subname)); 	
										
			});	
			//	$("#acHead").addClass('chosen_a');
			
		},'json');
	
	});
	
    return (
		<div>
		  <AcademicPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="5">
					<Card>
					  <form action="" method="post" role="form" id="noteform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Add Notes</strong>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Title <span className="text-danger">*</span></Label>
								  <Input type="text" name="title" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Description <span className="text-danger">*</span></Label>
								  <Input type="textarea" name="desc" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Attachment </Label>
								  <Input type="file" name="attach"  onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Class <span className="text-danger">*</span></Label>
								  <select name="cls" onChange={this.onChange} className="form-control" id="clas" required> 
									<option value="">Select Class</option>
									{
										items.map(function (item) {
											return <option value={item.id }>{item.class}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Section <span className="text-danger">*</span></Label>
								  <select name="section" onChange={this.onChange} className="form-control" id="secs" required>
												
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Subject <span className="text-danger">*</span></Label>
								  <select name="subject" onChange={this.onChange} className="form-control" id="sub" required>
												
								  </select>
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				  <Col md="7">
				   <Card>
					<CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Title</th>
								<th>Class</th>
								<th>Section</th>
								<th>Subject</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.data.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.title}</td>
									<td>{item.cls}</td>
									<td>{item.sec}</td>
									<td>{item.subj}</td>
									<td>
										<button name="editsub" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
										&nbsp;&nbsp;
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>

							 )}
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Notes;


// WEBPACK FOOTER //
// ./src/assignment/Notes/Notes.js